module.exports = __webpack_public_path__ + "img/76.3404b5e4.svg";